import script from "./PaymentType_Create_Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentType_Create_Edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__